module.exports = __webpack_public_path__ + "media/images/writer/community/sp-title-5df7faca5e39bf987fc8787bbe6936f8.png";